import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';
import { common as c, operators as o } from '@pendo/aggregations';

export default {
    name: 'EmailElementsTableAggregation',
    productArea: PRODUCT_AREAS.ORCHESTRATE,
    subProductArea: SUB_PRODUCT_AREAS.EMAIL,
    responseFormat: 'rows',
    build: ({
        appIds,
        timeSeries,
        blacklist = 'apply',
        segmentId,
        emailId,
        isEmailIntegrated,
    }: {
        appIds: c.AppIdType;
        timeSeries: c.TimeSeries;
        blacklist?: c.BlacklistTypes;
        segmentId?: string;
        emailId?: string;
        isEmailIntegrated: boolean;
    }) => {
        const basePipeline = [
            o.sources.emailEvents({
                appId: appIds,
                blacklist,
                timeSeries,
                targetType: 'campaign',
                targetId: emailId,
            }),
            o.segment(segmentId),
            o.filter('type == "email:pendo:clicked"'),
        ];

        const pendoEmailPipeline = [
            o.unmarshal({
                eventProperties: 'properties',
            }),
            o.evalExpression({
                elementData: 'lookup(eventProperties, "linkTags")',
            }),
            o.filter('!isNil(elementData)'),
            o.evalExpression({
                domId: 'lookup(elementData, "dom-id")',
            }),
            o.evalExpression({
                clickType: 'if(startsWith(domId, "pendo-"), split(domId, "-")[1], "unknown")',
            }),
            o.filter('domId != ""'),
            o.group(['domId', 'clickType'], o.groupField('visitorClickedList', o.list('visitorId'))),
            o.evalExpression({
                clickCount: 'len(visitorClickedList)',
                clickCountUnique: 'lenUnique(visitorClickedList)',
            }),
            o.select({
                id: 'domId',
                type: 'clickType',
                count: 'clickCount',
                countUnique: 'clickCountUnique',
            }),
        ];

        const integrationEmailPipeline = [
            o.unmarshal({
                _properties: 'properties',
            }),
            o.evalExpression({
                link: 'if(_properties.link, _properties.link, "")',
            }),
            o.evalExpression({
                strippedLink: 'split(link, "?")[0]',
            }),
            o.group(['strippedLink'], o.groupField('visitorClickedList', o.list('visitorId'))),
            o.evalExpression({
                clickCount: 'len(visitorClickedList)',
                clickCountUnique: 'lenUnique(visitorClickedList)',
            }),
            o.select({
                id: 'strippedLink',
                link: 'strippedLink',
                count: 'clickCount',
                countUnique: 'clickCountUnique',
            }),
        ];

        const emailPipeline = isEmailIntegrated ? integrationEmailPipeline : pendoEmailPipeline;

        return o.pipeline(...basePipeline, ...emailPipeline);
    },
};
